/* @flow */
import React from 'react';
import Relay from 'react-relay';
import { FormattedMessage } from 'react-intl';

import { css } from 'glamor';

import FillHorizontal from 'depop/components/layout/FillHorizontal';

import ShopLink from 'depop/apps/shops/links/ShopLink';

import Logo from 'depop/components/Logo';
import HeaderMenuItem from './HeaderMenuItem';
import Link from 'depop/components/Link';
import Logout from './Logout';

import SearchLink from './links/SearchLink';
import DownloadLink from './links/DownloadLink';
import DownloadLinkWinAB from './links/DownloadLinkWinAB';
import LoginLink from './links/LoginLink';

import cookies from 'browser-cookies';

import { trackDownLoadAppHeader } from 'depop/utils/tracking';

class DesktopHeader extends React.Component {

  scrollToTop () {
    return window.scrollTo(0, 0);
  }

  render() {
    const { user } = this.props;
    const scrollToTop = this.scrollToTop;

    return (
      <nav>
        <FillHorizontal>
          <div
            {...css({
              flexGrow: '0',
              flexShrink: '0',
              width: '90px',
            })}>
            <Link
              to={{ pathname: '/' }}
              onClick={scrollToTop}
              {...css({
                display: 'block',
                verticalAlign: 'bottom',
              })}>
              <Logo />
            </Link>
          </div>
          <FillHorizontal.Spacer size={24} />
          <HeaderMenuItem expanded>
            <SearchLink />
          </HeaderMenuItem>
          <FillHorizontal.Separator size={24} />
          <HeaderMenuItem expanded>
            {user
              ? <ShopLink user={user}>
                  <FormattedMessage
                    id="app.profileLabel"
                    description="Profile Label"
                    defaultMessage="Profile"
                  />
                </ShopLink>
              : <DownloadLinkWinAB /> || <DownloadLink onclick={() => trackDownLoadAppHeader({source: 'desktop'})} />}
          </HeaderMenuItem>
          <FillHorizontal.Separator size={24} />
          <HeaderMenuItem expanded>
            {user ? <Logout /> : <LoginLink />}
          </HeaderMenuItem>
        </FillHorizontal>
      </nav>
    );
  }
}

export default Relay.createContainer(DesktopHeader, {
  fragments: {
    user: () => Relay.QL`
      fragment on User {
        ${ShopLink.getFragment('user')}
        id
      }
    `,
  },
});



// WEBPACK FOOTER //
// ../src/client/components/layout/navigation/DesktopHeader.js